export default [
  {
    // [0]
    key: "id",
    label: "ID",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [1]
    key: "abbreviation",
    label: "abbreviation",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [2]
    key: "description",
    label: "description",
    visible: true,
  },
  {
    // [3]
    key: "viatic_cost",
    label: "viatic cost",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [3]
    key: "viatic_status",
    label: "viatic status",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [3]
    key: "payroll_apply",
    label: "Payroll Apply",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [4]
    key: "tracking",
    label: "tracking",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    // [5]
    key: "actions",
    label: "actions",
    visible: true,
    thClass: "text-center",
    tdClass: "text-center",
  },
];
